


$('.js-char-counter').each(function(){
    const textInput = $(this).closest('.form-field').find('input')[0]
    const charCounter = this

    // Get the maxlength attribute value
    const maxLength = parseInt(textInput.getAttribute('maxlength'));

    // Function to update the character counter
    function updateCharCounter() {
        const currentLength = textInput.value.length;
        charCounter.textContent = currentLength;
    }

    // Update counter on input event
    textInput.addEventListener('input', updateCharCounter);

    // Initialize counter on page load
    updateCharCounter();
})

